<template>
  <footer class="footer">
    <p>
      &copy; 2026 Backyard Hibachi.
      <a href="tel:6267165717">(626) 716-5717</a>
      | <a href="/">Home</a>
      <template v-if="showBlog"> | <a href="/blog">Blog</a></template>
      | <a href="/booking">Book</a>
      <template v-if="suffix"> | {{ suffix }}</template>
    </p>
  </footer>
</template>

<script>
export default {
  props: {
    showBlog: {
      type: Boolean,
      default: false
    },
    suffix: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.footer {
  padding: 3rem 2rem;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, .04);
  font-size: .78rem;
  color: rgba(255, 255, 255, .3);
}

.footer a {
  color: var(--gold);
}
</style>
